  <script>
    import { onDestroy } from 'svelte'

    import { Route, Router, navigate } from 'svelte-routing'
    import { Spinner, Table, Container, Row, Col, Card, Button, CardHeader, CardTitle } from 'sveltestrap'
    import date from 'date-and-time'
    import mapper from '../../middleware/database/mapper'
    import { Agents } from '../../middleware/database/agents'
    import { currentUser } from '../../stores/current_user'

    let agents = []
    let filteredAgents = []
    let unsubscribeQuery = null
    let loading = false
    let showPage = false

    $: if (!$currentUser) {
        loading = false
        showPage = false
    } else {
        loading = true
        showPage = true
    }

    $: if (loading) {
      //fetchAgents(add filters)
      fetchAgents()
    }

    const fetchAgents = () => {
        unsubscribeQuery = Agents.findAll().onSnapshot(docs => {
          agents = mapper.toList(docs)
          filteredAgents = [...agents]
          loading = false
        }, err => {
          console.log(`Encountered error: ${err}`)
        })
    }

    onDestroy(() => {
        if (unsubscribeQuery)
          unsubscribeQuery()
    })
</script>

<style>
  .cardHeader :global(.card-header) {
    background-color: #fff;
  }
</style>

{#if showPage}
<Container class="mt-5">
  <Row>
    <Col>
      <div class="cardHeader">

        <Card>
          <CardHeader>
            <h4 class="float-left">Agents</h4>
            <Button class="float-right" color="primary" onclick={() => navigate("/agents/create")} disabled={!$currentUser.isAdmin}>Create new agent</Button>
          </CardHeader>
          {#if loading}
          <Spinner size="lg" color="dark" type="grow" />
        {:else}
          <Table hover>
            <thead>
              <tr>
                  <th>Id</th>
                  <th>Name</th>
              </tr>
            </thead>
            <tbody>
              {#each filteredAgents as agent (agent.id)}
              <tr on:click={() => navigate(`/agents/edit/${agent.id}`)} style="cursor: pointer">
                  <td>{agent.id}</td>
                  <td>{agent.name}</td>
              </tr>
              {/each}
            </tbody>
          </Table>
        {/if}

        </Card>
      </div>
    </Col>
  </Row>
</Container>
{/if}